import React, { Suspense } from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate, useParams } from 'react-router-dom';

const GenieclassReport = React.lazy(
  () => import('genieclass/GenieclassReport'),
);

const GenieclassReportPage = () => {
  const { onlineLessonId } = useParams();
  const navigate = useNavigate();

  return (
    <div>
      <Helmet>
        <title>Geniebook - GenieClass Performance Report</title>
        <meta name="description" content="GenieClass" />
      </Helmet>
      <Suspense>
        <GenieclassReport
          onClick={() => navigate(-1)}
          onlineLessonId={onlineLessonId ? parseInt(onlineLessonId) : 0}
        />
      </Suspense>
    </div>
  );
};

export default GenieclassReportPage;
